import Vue from 'vue';
import Router, {NavigationGuard, Route} from 'vue-router';
import Upload from './views/Upload.vue';
import Download from './views/Download.vue';
import LetterboxContent from './views/LetterboxContent.vue';
import LetterboxCreate from './views/LetterboxCreate.vue';
import LetterboxUpload from './views/LetterboxUpload.vue';
import Privacy from './views/PrivacyStatement.vue';
import TermsOfService from "@/views/TermsOfService.vue";
import Imprint from '@/views/Imprint.vue';
import Account from "@/views/Account.vue";
import Admin from "@/views/Admin.vue";
import RedeemInvitation from "@/views/RedeemInvitation.vue";
import store from "@/store";
import Pro from "@/views/Pro.vue";
import Home from "@/views/Home.vue";
import ResetPasswordForm from "@/views/ResetPasswordForm.vue";
import ResetPasswordInit from "@/views/ResetPasswordInit.vue";

Vue.use(Router);

const onlyLoggedIn: NavigationGuard<Vue> = (to, from, next) => {
    //This guard is only needed if we have the login enforced:
    //If not logged in, redirect to login
    if (!store.getters.isLoggedIn) {
        next('/?loginandgoto=' + to.path);
    } else {
        next();
    }
};

//Redirect an loggedin user to his account, useful for letting loggedin users not see a route
const redirectLoggedInUsersToAccount: NavigationGuard<Vue> = (to, from, next) => {
  if (store.getters.isLoggedIn) {
    next("/account");
  } else {
    next();
  }
};

export default new Router({
  mode: 'history',
  base: '',
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
    },
    {
      path: '/upload',
      name: 'upload',
      component: Upload,
    },
    {
      path: '/pro',
      name: 'pro',
      component: Pro,
      beforeEnter: redirectLoggedInUsersToAccount,
    },
    {
      path: "/download/:id",
      name: 'download',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: Download,
    },
      {
          path: '/account',
          name: 'account',
          // route level code-splitting
          // this generates a separate chunk (about.[hash].js) for this route
          // which is lazy-loaded when the route is visited.
          component: Account,
          beforeEnter: onlyLoggedIn,
      },
      {
          path: '/admin',
          name: 'admin',
          // route level code-splitting
          // this generates a separate chunk (about.[hash].js) for this route
          // which is lazy-loaded when the route is visited.
          component: Admin,
          beforeEnter: onlyLoggedIn,
      },
    {
      path: '/resetpassword',
      name: 'resetpassword',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: ResetPasswordInit,
    },
    {
      path: '/resetpassword/:nonce',
      name: 'resetpasswordform',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: ResetPasswordForm,
    },
      {
          path: '/redeem/:name/:token',
          name: 'redeem',
          // route level code-splitting
          // this generates a separate chunk (about.[hash].js) for this route
          // which is lazy-loaded when the route is visited.
          component: RedeemInvitation,
      },
      {
          path: '/letterbox',
          name: 'letterbox-create',
          // route level code-splitting
          // this generates a separate chunk (about.[hash].js) for this route
          // which is lazy-loaded when the route is visited.
          component: LetterboxCreate,
      },
      {
          path: '/letterbox/:id/download',
          name: 'letterbox-content',
          // route level code-splitting
          // this generates a separate chunk (about.[hash].js) for this route
          // which is lazy-loaded when the route is visited.
          component: LetterboxContent,
      },
      {
          path: '/letterbox/:id/upload',
          name: 'letterbox-upload',
          // route level code-splitting
          // this generates a separate chunk (about.[hash].js) for this route
          // which is lazy-loaded when the route is visited.
          component: LetterboxUpload,
      },
    {
      path: '/agb',
      name: 'ToS',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: TermsOfService,
    },
    {
      path: '/privacy',
      name: 'Privacy',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: Privacy,
    },
    {
      path: '/imprint',
      name: 'Imprint',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: Imprint,
    },
    {path: '*', redirect: '/'},
  ],
});
